module.exports = __webpack_public_path__ + "static/media/RP-B_C_Embroidery_Accademia_White_3955_3377_3364.04f6e9b4.png";